import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  padding: 6px 16px 0 6px;
  overflow: hidden;

  .search-filter {
    float: right;
    margin-right: 35px;
  }
`;

const CalendarWrapper = styled.div<{ $iconColor?: string }>`
  .entity-icon {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 5px;
    gap: 4px;
    background: ${(props) => props.theme.colors.widget_background};
    border: 1.5px solid ${(props) => props.$iconColor || props.theme.colors.inactive};
    border-radius: 100px;

    &.map-focus-button {
      border: 1.5px solid ${(props) => props.$iconColor || props.theme.colors.inactive};
      color: inherit;
      cursor: pointer;
      font: inherit;
    }

    .icon {
      color: ${(props) => props.$iconColor || props.theme.colors.inactive};
    }

    .line {
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -1px;
      border: 1px solid ${(props) => props.theme.colors.surface_muted};
      height: 58px;
      width: 0px;
    }
  }

  &:last-child {
    .line {
      display: none;
    }
  }

  &.indented {
    padding-left: 30px;
  }

  /* Alert kept on the map by clicking the row (see AlertFocusStore). Outline only - a
     box-shadow ring follows the pill's radius without shifting the row's layout. */
  &.map-pinned {
    .entity-icon {
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.main_cta};
    }
  }
`;

export default { Wrapper, CalendarWrapper };
